/*
 * module.js - The description of the module.
 */

Fundu.Pages.GuaranteeRegistration = (function($) {

    // Properties
    ///////////////////////////
    var _submitButton = false;
    var _guarantorRegistrationForm = false;

    var _submitLock = false;

    // Private Methods
    ///////////////////////////
    var selectElements = function() {
        _submitButton = $("#registrationSubmitButton");
        _guarantorRegistrationForm = $("#guarantorRegistrationForm");
    };

    var initializeSubmitButton = function() {
        _submitButton.on('click', function (e) {
            e.preventDefault();
            register();
        });
    };

    var register = function() {
        if(!_submitLock) {
            _submitLock = true;
            $.ajax({
                type: "POST",
                data: _guarantorRegistrationForm.serialize(),
                url: _guarantorRegistrationForm.attr('action')
            }).done(function (res) {
                resetErrors();

                if (res.redirect) {
                    window.location.href = res.redirect;
                } else {
                    console.error("Didn't receive redirect after guarantor registration");
                    Fundu.Helpers.Notify.error("global", "error.generic");
                }

                _submitLock = false;

            }).fail(function (res) {
                resetErrors();

                var errors = res.responseJSON && res.responseJSON.errors;

                if (errors) {
                    displayAddressErrors(errors);
                    displayContactErrors(errors);
                    displayConsentErrors(errors);
                } else {
                    console.error("Registration failed with unexpected error");
                    Fundu.Helpers.Notify.error("global", "error.generic");
                }

                _submitLock = false;
            });
        }
    };

    var resetErrors = function() {
        $('.has-error').removeClass("has-error");
        $('span.help-block').remove();
    };

    var displayAddressErrors = function(errors) {

        displayFieldErrors(errors, "registrationName");
        displayFieldErrors(errors, "registrationStreet");
        displayFieldErrors(errors, "registrationPostalCode");
        displayFieldErrors(errors, "registrationCity");

    };

    var displayContactErrors = function(errors) {

        displayFieldErrors(errors, "registrationEmail");
        displayFieldErrors(errors, "registrationPhoneNumber");

    };

    var displayConsentErrors = function(errors) {

        displayFieldErrors(errors, "marketingOptIn");
        displayFieldErrors(errors, "acceptTerms");

    };

    var displayFieldErrors = function(errors, fieldName) {
        if(errors[fieldName] && errors[fieldName].length > 0) {
            var input = $("input[name=" + fieldName + "]");
            var formGroup = input.parents('.form-group');
            formGroup.addClass("has-error");
            errors[fieldName].forEach(function(e) {formGroup.append('<span class="help-block">' + e + '</span>')});
        }
    };

    // Init
    ///////////////////////////
    var initialize = function() {
        selectElements();
        initializeSubmitButton();

        return $.Deferred().resolve(true);
    };

    var finalize = function() {};

    // Reveal public methods
    return {
        init: initialize,
        finalize: finalize
    }

})(jQuery);
